import React, {useCallback, useEffect} from 'react';

import {CodonTranslationTable} from 'biojs/BioConstants';
import GeneticCodeDropdown from 'molbio/translations/GeneticCodeDropdown';
import {maybeGetValueFromConfig} from 'pipelines/generalized-step-config-editor/step-config-settings/StepConfigSettingsUtils';
import {CustomComponentEditorProps} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';

export const STANDARD_GENETIC_CODE = CodonTranslationTable.STANDARD;

export default function GeneticCodeEditor({
  config,
  onChangeConfig,
  disabled,
}: CustomComponentEditorProps): JSX.Element {
  const configuredGeneticCode =
    (maybeGetValueFromConfig(config, ['geneticCode']) as CodonTranslationTable | null | undefined) ?? null;

  // geneticCode is a required enum, so a config missing it fails validation and blocks Submit. Persist
  // the Standard default the dropdown displays, without overwriting an existing non-standard selection.
  useEffect(() => {
    if (configuredGeneticCode == null) {
      onChangeConfig(config, ['geneticCode'], STANDARD_GENETIC_CODE);
    }
  }, [config, configuredGeneticCode, onChangeConfig]);

  const handleSelectGeneticCode = useCallback(
    (geneticCode: CodonTranslationTable | null) => {
      onChangeConfig(config, ['geneticCode'], geneticCode);
    },
    [config, onChangeConfig]
  );

  return (
    <GeneticCodeDropdown
      geneticCode={configuredGeneticCode ?? STANDARD_GENETIC_CODE}
      onSelectGeneticCode={handleSelectGeneticCode}
      disabled={Boolean(disabled)}
    />
  );
}
